import { Link, LinkProps } from '@mui/material';
import { FC } from 'react';
import { useHref } from 'react-router-dom';

interface HrefLinkProps extends Omit<LinkProps, 'href'> {
  to: string;
}

export const HrefLink: FC<HrefLinkProps> = ({ to, children, ...props }) => {
  const href = useHref(to);
  return <Link href={href} {...props}>{children}</Link>;
};
